<section class="timeline">
  @if (heading()) {
    <h2 class="timeline__title">{{ heading() }}</h2>
  }
  @if (subheading()) {
    <p class="timeline__sub">{{ subheading() }}</p>
  }

  <!-- An ordered list, not a stack of divs: these are steps in sequence, and a
       screen reader should announce them as such. -->
  <ol class="timeline__rows">
    @for (row of rows(); track row.when) {
      <li class="timeline__row">
        <span class="timeline__dot" aria-hidden="true">
          <ion-icon [name]="row.icon"></ion-icon>
        </span>
        <span class="timeline__body">
          <span class="timeline__when">{{ row.when }}</span>
          <span class="timeline__row-title">{{ row.title }}</span>
          <span class="timeline__detail">{{ row.detail }}</span>
        </span>
      </li>
    }
  </ol>
</section>
